// Dashboard "Remote Support — live sessions" section (support-agent side).
// Polls the active-sessions endpoint while mounted; renders nothing unless
// an owner who granted this account support access has a canvas open right
// now (sessions only exist while the owner is live). Also shows the
// "session ended" notice after a session closes.

const React = require('react');
const { createElement: h, useState, useEffect } = React;
const { listActiveSupportSessions } = require('../lib/supportAccess');
require('./SupportSessionsSection.css');

var POLL_MS = 10000;

function SupportSessionsSection(props) {
  var onJoin = typeof props.onJoin === 'function' ? props.onJoin : function() {};
  var notice = props.notice || '';
  var onDismissNotice = typeof props.onDismissNotice === 'function' ? props.onDismissNotice : function() {};
  var [sessions, setSessions] = useState([]);

  useEffect(function() {
    var mounted = true;
    function refresh() {
      listActiveSupportSessions()
        .then(function(list) { if (mounted) setSessions(list); })
        .catch(function() {});
    }
    refresh();
    var timer = setInterval(refresh, POLL_MS);
    window.addEventListener('focus', refresh);
    return function() {
      mounted = false;
      clearInterval(timer);
      window.removeEventListener('focus', refresh);
    };
  }, []);

  if (!sessions.length && !notice) return null;

  return h(React.Fragment, null,
    notice
      ? h('div', { className: 'support-session-notice' },
          h('span', null, notice),
          h('button', { onClick: onDismissNotice, title: 'Dismiss' }, '✕')
        )
      : null,
    sessions.length
      ? h('section', { className: 'wlp-support-section' },
          h('h2', { className: 'wlp-section-title' },
            'Remote Support — live sessions',
            h('span', { className: 'wlp-support-live-dot', title: 'Live now' })
          ),
          h('p', { className: 'wlp-support-section__hint' },
            'These users added you as a support agent and have a workflow open right now. Join to work on their canvas together.'),
          h('div', { className: 'wlp-support-list' },
            sessions.map(function(session) {
              return h('div', { className: 'wlp-support-card', key: session.ownerId + ':' + session.workflowId },
                h('div', { className: 'wlp-support-card__info' },
                  h('div', { className: 'wlp-support-card__name' }, session.workflowName || 'Untitled'),
                  h('div', { className: 'wlp-support-card__owner' }, 'by ' + (session.ownerUsername || 'unknown'))
                ),
                h('button', {
                  className: 'wlp-support-card__join',
                  onClick: function() { onJoin(session); }
                }, 'Join session')
              );
            })
          )
        )
      : null
  );
}

module.exports = SupportSessionsSection;
